import {
	registerDecorator,
	ValidationArguments,
	ValidationOptions,
	ValidatorConstraint,
	ValidatorConstraintInterface
} from "class-validator";

@ValidatorConstraint({ name: 'IsIncludedIn' })
class IsIncludedInValidator implements ValidatorConstraintInterface {
	validate(value: number, args: ValidationArguments) {
		const [allowedValues] = args.constraints;

		return allowedValues.includes(value);
	}

	defaultMessage(args: ValidationArguments) {
		const [allowedValues] = args.constraints;

		return `The value must be one of the following values: ${allowedValues.join(', ')}`;
	}
}

export const IsIncludedIn = (allowedValues: number[], validationOptions?: ValidationOptions) =>
	(object: Record<never, never>, propertyName: string) => {
		registerDecorator({
			name: 'IsIncludedIn',
			target: object.constructor,
			propertyName,
			options: validationOptions,
			constraints: [allowedValues],
			validator: IsIncludedInValidator,
		});
	};
